var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHezaigongkuang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687",
    d: "M8.37451 0L8.37451 4.48913",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 684",
    d: "M10.9224 8.94792V7.37066L6.43323 5.49008L2.06543 7.37066V12.9517L6.63039 15.4238L8.31381 14.4683",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 685",
    d: "M2.06543 7.37067L6.61522 9.25125L10.983 7.37067",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 686",
    d: "M6.61523 9.25122V14.893",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13",
    d: "M8.37444 5.1564L6.5882 3.14403L10.1607 3.14403L8.37444 5.1564Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631342",
    d: "M11.0146 10.3623L13.7455 13.0932L11.8432 14.9955L9.62862 14.3881L9.1063 12.2707L11.0146 10.3623Z",
    fill: "#C2C2C2",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 688",
    d: "M12.3663 11.7415L14.4526 9.65524",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 689",
    d: "M13.398 8.31909L15.7891 10.7101",
    stroke: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHezaigongkuang);
export default __webpack_public_path__ + "static/media/hezaigongkuang.11f0d7b767b7f5af832f0926221e2914.svg";
export { ForwardRef as ReactComponent };